import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

import games1 from './pictures/games1.jpeg';
import games2 from './pictures/games2.jpeg';
import mm1 from './pictures/MM1.jpeg';

const AuMM1 = () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>Autumn Member Meeting 1: Check-in & Checkmate</h2>
                    <p class="site-post-meta">October 3, 2025</p>
                    <hr></hr>
                </section>
                <section>
                    <p>Hi WiC Members!

                    <br></br>
                    <br></br>

                    Thank you to everyone who joined us for our first member meeting of the school year! We had a wonderful time meeting with so many new and returning members, playing games, and enjoying some snacks together.

                    <br></br>
                    <br></br>                    
                    We all had the opportunity to learn more about WiC and future events and opportunities, like committees. We also gave members the opportunity to get early access to our committe applications! Everyone also got the chance to meet new WiC members and reconnect with old friends through fun and exciting board games! 
                    <br></br>
                    <br></br>
                    We hope everyone had an amazing time and were able to make some friends going into the new school year!                    
                    
                    </p>
                    <img src={mm1} alt="Attendees posing after the completion of the event."/>
                    <img src={games1} alt="Attendees playing games at the event."/>
                    <img src={games2} alt="Attendees playing games at the event."/>
                </section>
                
            </div>
        </div>      
      </div>
    </div>
  );
};

export default AuMM1;
